"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breadcrumb = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var BreadcrumbAction_1 = require("@/pages/search/actions/sfilter/BreadcrumbAction");
var mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, state.breadcrumb), { h1: ownProps.h1 ? ownProps.h1 : '' })); };
var mapDispatchToProps = function (dispatch) { return ({
    onBreadcrumbSearchClicked: function () {
        return dispatch(BreadcrumbAction_1.default.onBreadcrumbSearchClicked());
    },
}); };
exports.breadcrumb = function (props) {
    var renderBreadcrumbItems = function (props, items) {
        var elements = items.map(function (item, index) {
            var attrs = {};
            if (item.hidden)
                return;
            var tag = null;
            if (item.action === 'searchPage') {
                attrs.onClick = props.onBreadcrumbSearchClicked;
                tag = (React.createElement("a", __assign({ href: "#" }, attrs), item.name));
            }
            else if (item.link) {
                attrs.href = item.link;
                tag = React.createElement("a", __assign({}, attrs), item.name);
            }
            else {
                tag = React.createElement("span", null, item.name);
            }
            return (React.createElement("li", { key: index, className: "c-breadcrumb__item" }, tag));
        });
        if (props.h1) {
            elements.push(React.createElement("li", { key: items.length, className: "c-breadcrumb__item" },
                React.createElement("h1", null, props.h1)));
        }
        return elements;
    };
    return (React.createElement("ul", { className: "c-breadcrumb__items" }, renderBreadcrumbItems(props, props.breadcrumbList)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.breadcrumb);
